import {GetHeadingParams} from './CoachesTeamSummaryCard.types';

export function getHeading({
  isBusinessCoach,
  isBusinessLeader,
  tt,
}: GetHeadingParams) {
  if (isBusinessCoach) {
    return tt('header.coach', 'Coaches Summary');
  } else if (isBusinessLeader) {
    return tt('header.leader', 'Coaches & Teams Summary');
  }
  return null;
}
